import { render, staticRenderFns } from "./IconWrap.vue?vue&type=template&id=305890e5&"
import script from "./IconWrap.vue?vue&type=script&lang=js&"
export * from "./IconWrap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports